module.exports = __webpack_public_path__ + "img/ab1.dc40c2c9.png";